import { request } from '@/api/request';
import type { Answer } from '@/types/models/answer';
import type { ScopingAnswer } from '@/types/models/scopingAnswer';
import type { ControlBookmark } from '@/types/models/control';

const getAssessmentStatus = () => request('GET', `/assessment/status`);

export type ScopingAnswersResponse = Record<string, ScopingAnswer>;
const getScopingAnswers = () =>
  request<ScopingAnswersResponse>('GET', '/assessment/scoping-answers');

const changeScopingAnswer = (domainID: string, answer: any, notes: any) =>
  request<ScopingAnswer>('PUT', `/assessment/scoping-answers/${domainID}`, { answer, notes });

const completeScopingQuestions = () => request('PUT', '/assessment/scoping-answers/complete');

const confirmScopingAnswer = (domainID: string) =>
  request('POST', `/assessment/scoping-answers/${domainID}/confirm-control-update`);

export type ControlAnswersResponse = Answer[];
const getControlAnswers = () => request<ControlAnswersResponse>('GET', '/assessment/answers/v2');

const answerControl = (controlID: string, answer: Partial<Answer>) =>
  request<Answer>('PUT', `/assessment/answers/${controlID}`, answer);

const confirmAnswerControlUpdate = (answerID: string) =>
  request('POST', `/assessment/answers/${answerID}/confirm-answer-control-update`);

const removeControlAnswer = (controlID: string) =>
  request('PUT', `/assessment/answers/${controlID}/remove`);

const archiveProductAnswer = (productID: string, answerID: string) =>
  request('PUT', `/assessment/product/${productID}/answers/${answerID}/archive`);

const submitAssessment = () => request('POST', `/assessment/complete`);

const getControlBookmarks = () =>
  request<ControlBookmark[]>('GET', '/assessment/control-bookmarks');

const bookmarkControl = (controlID: string) =>
  request<ControlBookmark>('POST', `/assessment/control/${controlID}/bookmark`);

const unbookmarkControl = (controlID: string) =>
  request<ControlBookmark>('POST', `/assessment/control/${controlID}/unbookmark`);

const getNewInscopeDomains = () => request<string[]>('GET', '/quick-answer/new-in-scope-domains');

export default {
  getAssessmentStatus,
  getScopingAnswers,
  changeScopingAnswer,
  completeScopingQuestions,
  confirmScopingAnswer,
  getControlAnswers,
  answerControl,
  removeControlAnswer,
  archiveProductAnswer,
  submitAssessment,
  confirmAnswerControlUpdate,
  getControlBookmarks,
  bookmarkControl,
  unbookmarkControl,
  getNewInscopeDomains,
};
